import { render, staticRenderFns } from "./KezSelect.vue?vue&type=template&id=25cff832&scoped=true&"
import script from "./KezSelect.vue?vue&type=script&lang=js&"
export * from "./KezSelect.vue?vue&type=script&lang=js&"
import style0 from "./KezSelect.vue?vue&type=style&index=0&id=25cff832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cff832",
  null
  
)

component.options.__file = "KezSelect.vue"
export default component.exports